// IMPORT REACT
import React from 'react';

// IMPORT COMPONENTS
import YAHeader from '../../components/Header';
import YAFooter from '../../components/Footer';

// IMPORT STYLES
import { Sc_LayoutWrapper, Sc_PageWrapper  } from '../styles';


const Layout = ({ page, lang, bloginfo, header, body, modals }) => {
    
    return (
    	<Sc_LayoutWrapper>
      	<Sc_PageWrapper>
        <YAHeader lang={lang} page={page}>
          { header }
        </YAHeader>
        { body }
        </Sc_PageWrapper>
        <YAFooter lang={lang} bloginfo={bloginfo} />
        { modals }
      </Sc_LayoutWrapper>
    )
    
}
export default Layout;